import clsx from 'clsx';
import { BetMsgModel, BETTING_CODE, ParlayTicketModel } from '@/hooks/query';
import { BetInput } from '../bet-input';
import { BetKeypad } from '../bet-keypad';
import { Notice, TextErrorParlay } from '../bet-msg';
import { BetSlipParlayPayout } from '../payout';
import { betslipStyle } from '@/features/betslip/betslip.style';

interface BetTicketParlayProps {
	ticket: ParlayTicketModel;
	ticketMinBet: number;
	canBetResult?: BetMsgModel;
}

export const BetTicketParlay = ({
	ticket,
	ticketMinBet,
	canBetResult
}: BetTicketParlayProps) => {

	const canBet = canBetResult ? canBetResult.canBet : true;

	return (
		<div className={clsx('bet-slip-parlay', betslipStyle.betSlipParlay)}>
			<div className="bet-slip-parlay__wrap">
				<div className="bet-slip-parlay__container">
					<div className="bet-slip-parlay__header">
						<div className="bet-slip-parlay__name">{ticket.Name}</div>
					</div>
				</div>
				<div className="bet-slip-parlay__stake">
					<BetInput
						type={'small'}
						isParlay={true}
						canBet={canBet}
						ticketKey={ticket.key}
						ticketMinBet={ticketMinBet}
						ticketBetCount={ticket.BetCount}
					/>
					{canBet ? <BetSlipParlayPayout payout={ticket.payout} /> : null}
					{
						canBetResult && ([BETTING_CODE.ParlayMaxBetLessThanMinBet, BETTING_CODE.ParlayNoComboAvailable] as Array<number>).includes(canBetResult?.code ?? 0) ? (
							<TextErrorParlay msg={canBetResult.msg} />
						) : null
					}
				</div>
			</div>
			<BetKeypad
				isExpand={true}
				isParlay={true}
				ticketKey={ticket.key}
				ticketStake={ticket.stake}
				ticketMaxBet={ticket.MaxBet}
			/>
			{
				canBetResult && ([BETTING_CODE.ParlayMinOdds, BETTING_CODE.ParlayComboByPool] as Array<number>).includes(canBetResult?.code ?? 0) ? (
					<Notice
						code={canBetResult.code}
						msg={canBetResult.msg}
						msgDetails={ticket.ErrorMessageDetails}
						msgResourceKey={canBetResult.msgResourceKey}
						status={canBetResult.cssStatus}
					/>
				) : null
			}
		</div>
	);
};